import {
  Calculator,
  Certificate,
  CheckCircleOutlined,
  CoinsSwap,
  GraduationHat,
  Laptop,
  PlaySquare,
  Tag,
  Users,
  HomeLine,
  Trezor,
} from "components/icons";
import { ISidebarItems } from "types/types";

export function userSidebarItems(userLoggedIn: boolean) {
  const defaultMenu: ISidebarItems[] = [
    {
      id: "home",
      href: "/",
      icon: <Laptop color="inherit" sx={{ fontSize: 20 }} />,
    },
    {
      id: "atlasSidebarLink",
      href: "/atlas",
      icon: <GraduationHat color="inherit" sx={{ fontSize: 20 }} />,
    },
    {
      id: "quizzesSidebarLink",
      href: "/kviz",
      icon: <CheckCircleOutlined color="inherit" sx={{ fontSize: 20 }} />,
    },
    {
      id: "trezorSidebarLink",
      href: "/trezor",
      icon: <Trezor color="inherit" sx={{ fontSize: 20 }} />,
    },
    {
      id: "guide",
      to: "/proc-bitcoin/jak-vam-stosuj-cz-pomuze",
      icon: <PlaySquare color="inherit" sx={{ fontSize: 20 }} />,
    },
    {
      id: "pricing",
      to: "/cenik",
      icon: <Tag color="inherit" sx={{ fontSize: 20 }} />,
    },
    {
      id: "currencyPairs",
      to: "/menove-pary",
      icon: <CoinsSwap color="inherit" sx={{ fontSize: 20 }} />,
    },
    {
      id: "dcaCalc",
      href: "/#dca-kalkulacka",
      icon: <Calculator color="inherit" sx={{ fontSize: 20 }} />,
    },
    {
      id: "communityAndContact",
      href: "/#kontakt",
      icon: <Users color="inherit" sx={{ fontSize: 20 }} />,
    },
    {
      id: "terms",
      to: "/podminky",
      icon: <Certificate color="inherit" sx={{ fontSize: 20 }} />,
    },
  ];

  const menu: ISidebarItems[] = [
    {
      id: "overview",
      to: "/dashboard",
      icon: <HomeLine color="inherit" sx={{ fontSize: 20 }} />,
    },
    {
      id: "home",
      href: "/",
      icon: <Laptop color="inherit" sx={{ fontSize: 20 }} />,
      isSection: true,
    },
    {
      id: "atlasSidebarLink",
      href: "/atlas",
      icon: <GraduationHat color="inherit" sx={{ fontSize: 20 }} />,
      isSection: true,
    },
    {
      id: "quizzesSidebarLink",
      href: "/kviz",
      icon: <CheckCircleOutlined color="inherit" sx={{ fontSize: 20 }} />,
      isSection: true,
    },
    {
      id: "trezorSidebarLink",
      href: "/trezor",
      icon: <Trezor color="inherit" sx={{ fontSize: 20 }} />,
      isSection: true,
    },
    {
      id: "guide",
      to: "/proc-bitcoin/jak-vam-stosuj-cz-pomuze",
      icon: <PlaySquare color="inherit" sx={{ fontSize: 20 }} />,
      isSection: true,
    },
    {
      id: "dcaCalc",
      href: "/#dca-kalkulacka",
      icon: <Calculator color="inherit" sx={{ fontSize: 20 }} />,
      isSection: true,
    },
    {
      id: "communityAndContact",
      href: "/#kontakt",
      icon: <Users color="inherit" sx={{ fontSize: 20 }} />,
      isSection: true,
    },
    {
      id: "terms",
      to: "/podminky",
      icon: <Certificate color="inherit" sx={{ fontSize: 20 }} />,
      isSection: true,
    },
  ];

  return userLoggedIn ? menu : defaultMenu;
}
